"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Ajax = _interopRequireDefault(require("./utils/Ajax"));

var HubDbClient = /*#__PURE__*/function () {
  function HubDbClient() {
    (0, _classCallCheck2.default)(this, HubDbClient);
  }

  (0, _createClass2.default)(HubDbClient, [{
    key: "getTable",
    value: function getTable(portalId, tableId, callback) {
      return _Ajax.default.get(HubDbClient.apiPath + "/tables/" + tableId + "?portalId=" + portalId, callback);
    }
  }, {
    key: "getRow",
    value: function getRow(portalId, tableId, rowId, callback) {
      return _Ajax.default.get(HubDbClient.apiPath + "/tables/" + tableId + "/rows/" + rowId + "?portalId=" + portalId, callback);
    }
  }, {
    key: "listRows",
    value: function listRows(portalId, tableId) {
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (query.startsWith('?') || query.startsWith('&')) {
        query = query.substring(1);
      }

      return _Ajax.default.get(HubDbClient.apiPath + "/tables/" + tableId + "/rows?portalId=" + portalId + "&" + query, callback);
    }
  }], [{
    key: "apiPath",
    get: function get() {
      return 'https://api.hubapi.com/hubdb/api/v2';
    }
  }]);
  return HubDbClient;
}();

window.hubdbClient = new HubDbClient();


//////////////////
// WEBPACK FOOTER
// ./js/HubDbClient.js
// module id = 4
// module chunks = 2